import { getField, updateField } from 'vuex-map-fields';
import { types } from './mutation-types';

function getDefaultState() {
  return {
    companyName: '',
    nip: '',
    legalForm: '',
    industry: '',
    street: '',
    streetNumber: '',
    localNumber: '',
    city: '',
    zipCode: '',
    companyPhone: '',
    documentsWithDelivery: false,
  };
}

export const fvForm = {
  /*
  * namespace provide better map options
  * e.g:
  * without namespaced:
  * ...mapState({
  *   someProperty => state.moduleName.someState
  *   anotherProperty => state.moduleName.anotherProperty
  * })
  * with namespaced:
  * ...mapState('moduleName', ['someProperty','anotherProperty'])
  * using dispatch: this.$store.dispatch('moduleName/actionName', ...)
  * */
  namespaced: true,
  state: getDefaultState(),
  /*
  * yourGetter(state) { return state.yourState }
  * */
  getters: {
    getField,
  },
  /**
   * Mutations update the state
   * Mutations MUST BE SYNC
   * */
  mutations: {
    updateField,
    /*
    * Add product to state
    * @param {object} state - current state
    * @param {object} product - product object to insert to state
    */
    [types.SET_STATE](state, { prop, value }) {
      state[prop] = value;
    },
    [types.HYDRATE](state, payload = {}) {
      Object.assign(state, getDefaultState(), payload);
    },
  },
  /*
  * Actions commit mutations
  * This is place to get data from API
  * */
  actions: {
    /*
    * @param {context}
    * @param {payload}
    * */
    handleStateChange({ commit }, payload) {
      commit(types.SET_STATE, payload);
    },
    hydrate({ commit }, state) {
      commit(types.HYDRATE, state);
    },
    setFromBackend({ commit }, payload) {
      commit(types.SET_STATE, { prop: 'companyName', value: payload.name });
      commit(types.SET_STATE, { prop: 'nip', value: payload.vat_reg_num });
      commit(types.SET_STATE, { prop: 'street', value: payload.ad_line });
      commit(types.SET_STATE, { prop: 'city', value: payload.ad_city_name });
      commit(types.SET_STATE, { prop: 'zipCode', value: payload.ad_city_code });
      commit(types.SET_STATE, { prop: 'industry', value: '' });
      commit(types.SET_STATE, { prop: 'legalForm', value: '' });
    },
  },
};
